<template>
  <div class="column">
    <div class="row full-width">
      <div style="width: 30%" class="column">
        <label class="text-no-wrap">{{ $t('Type') }} </label>
        <el-select @input="updateRegexString" v-model="tagValueRegex.type">
          <el-option
            v-for="item in regexValueTypes"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div style="width: 70%" class="column">
        <label class="text-no-wrap">{{ $t('Values (or)') }} </label>
        <el-select
          v-model="tagValueRegex.values"
          default-first-option
          allow-create
          filterable
          multiple
          @input="updateRegexString"
          :no-match-text="$t('Type the value and press enter.')"
          :no-data-text="$t('Type the value and press enter.')"
        />
      </div>
    </div>

    <div class="column full-width q-mt-sm">
      <label class="text-no-wrap">{{ $t('Regex') }}</label>
      <input v-model="tagValueComputed" type="text" class="form-control" style="height: 40px" />
    </div>
  </div>
</template>
<script>
export default {
  props: ['value', 'tagValue'],
  data() {
    return {
      regexValueTypes: [
        { label: 'Equals', value: 'equals' },
        { label: 'Contains', value: 'contains' },
        { label: 'Starts With', value: 'startsWith' },
        { label: 'Ends With', value: 'endsWith' },
        { label: 'Does Not Euqal', value: 'doesNotEqual' },
        { label: 'Does Not Contain', value: 'doesNotContain' },
      ],
    };
  },
  computed: {
    tagValueRegex: {
      set(val) {
        this.$emit('update:value', val);
      },
      get() {
        return this.value;
      },
    },
    tagValueComputed: {
      set(val) {
        this.$emit('update:tagValue', val);
      },
      get() {
        return this.tagValue;
      },
    },
  },
  methods: {
    updateRegexString() {
      const { type, values } = this.tagValueRegex;
      if (!type || !values.length) return;
      //equals
      if (type === 'equals') {
        this.tagValueComputed = `eq:${values.join('|')}`;
      }
      //contains
      else if (type === 'contains') {
        this.tagValueComputed = `re:${values.join('|')}`;
        return;
      }
      //starts with
      else if (type === 'startsWith') {
        this.tagValueComputed = `re:^(${values.join('|')}).*`;
        return;
      }
      //ends with
      else if (type === 'endsWith') {
        this.tagValueComputed = `re:.*(${values.join('|')})$`;
        return;
      }
      //doesNotEqual
      else if (type === 'doesNotEqual') {
        this.tagValueComputed = `!eq:${values.join('|')}`;
        return;
      } //doesNotContain
      else if (type === 'doesNotContain') {
        this.tagValueComputed = `!re:${values.join('|')}`;
        return;
      }
    },
  },
};
</script>
